export default __webpack_public_path__ + "static/welding-products-4773bba7a798487d13da6f2cdbbed45e.png";